import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ShopProvider } from "./context/ShopContext";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Suppliers from "./pages/Suppliers";
import SupplierDetail from "./pages/SupplierDetail";
import Compare from "./pages/Compare";
import Cart from "./pages/Cart";
import Rfqs from "./pages/Rfqs";
import Orders from "./pages/Orders";
import Messages from "./pages/Messages";
import AdminPanel from "./pages/AdminPanel";
import OrderDetail from "./pages/OrderDetail";
import Shipments from "./pages/Shipments";
import Invoices from "./pages/Invoices";
import Inventory from "./pages/Inventory";
import Reports from "./pages/Reports";
import MediaLibrary from "./pages/MediaLibrary";
import SupplierHub from "./pages/SupplierHub";
import Support from "./pages/Support";
import Campaigns from "./pages/Campaigns";
import Firma from "./pages/Firma";
import ApiAccess from "./pages/ApiAccess";
import CategoryPage from "./pages/CategoryPage";
import SuppliersPublic from "./pages/SuppliersPublic";
import Storefront from "./pages/Storefront";
import CariHesaplar from "./pages/CariHesaplar";
import ChatRoom from "./pages/ChatRoom";
import ResetPassword from "./pages/ResetPassword";
import LegalPage from "./pages/legal/LegalPage";
import Contact from "./pages/legal/Contact";
import AtaAiWidget from "./components/AtaAiWidget";

const Spinner = () => (
    <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
            <img src="/logo-icon.png" alt="ATA Angora" className="w-16 h-16 object-contain animate-pulse" />
            <p className="text-sm text-muted-foreground">Yükleniyor...</p>
        </div>
    </div>
);

const Protected = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (location.state?.user) return children;
    if (loading) return <Spinner />;
    if (!user) return <Navigate to="/" replace />;
    return children;
};

function AppRouter() {
    const location = useLocation();
    // session_id kontrolü render sırasında yapılmalı (race condition önlemi)
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/kvkk" element={<LegalPage slug="kvkk" />} />
            <Route path="/gizlilik-politikasi" element={<LegalPage slug="gizlilik-politikasi" />} />
            <Route path="/cerez-politikasi" element={<LegalPage slug="cerez-politikasi" />} />
            <Route path="/mesafeli-satis-sozlesmesi" element={<LegalPage slug="mesafeli-satis-sozlesmesi" />} />
            <Route path="/on-bilgilendirme-formu" element={<LegalPage slug="on-bilgilendirme-formu" />} />
            <Route path="/iptal-iade-kosullari" element={<LegalPage slug="iptal-iade-kosullari" />} />
            <Route path="/kullanim-kosullari" element={<LegalPage slug="kullanim-kosullari" />} />
            <Route path="/kargo-teslimat" element={<LegalPage slug="kargo-teslimat" />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/sifre-sifirla" element={<ResetPassword />} />
            <Route path="/sayfa/:slug" element={<LegalPage />} />
            <Route path="/kategori/:slug" element={<CategoryPage />} />
            <Route path="/tedarikciler" element={<SuppliersPublic />} />
            <Route
                path="/panel"
                element={
                    <Protected>
                        <Layout />
                    </Protected>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="katalog" element={<Catalog />} />
                <Route path="urun/:productId" element={<ProductDetail />} />
                <Route path="tedarikciler" element={<Suppliers />} />
                <Route path="tedarikci/:supplierId" element={<SupplierDetail />} />
                <Route path="karsilastir" element={<Compare />} />
                <Route path="sepet" element={<Cart />} />
                <Route path="api-erisimi" element={<ApiAccess />} />
                <Route path="teklifler" element={<Rfqs />} />
                <Route path="siparisler" element={<Orders />} />
                <Route path="mesajlar" element={<Messages />} />
                <Route path="sohbet" element={<ChatRoom />} />
                <Route path="yonetim" element={<AdminPanel />} />
                <Route path="siparis/:orderId" element={<OrderDetail />} />
                <Route path="sevkiyat" element={<Shipments />} />
                <Route path="faturalar" element={<Invoices />} />
                <Route path="stok" element={<Inventory />} />
                <Route path="raporlar" element={<Reports />} />
                <Route path="medya" element={<MediaLibrary />} />
                <Route path="satis-paneli" element={<SupplierHub />} />
                <Route path="destek" element={<Support />} />
                <Route path="kampanyalar" element={<Campaigns />} />
                <Route path="firma" element={<Firma />} />
                <Route path="cari-hesaplar" element={<CariHesaplar />} />
                <Route path="vitrin/:supplierId" element={<Storefront />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ShopProvider>
                    <AppRouter />
                    <AtaAiWidget />
                    <Toaster position="top-right" richColors />
                </ShopProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
